"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
// Must include loading-spinner.css for animation to work correctly
var LoadingSpinner = function (props) {
    var _a = (0, hooks_1.useState)(false), hasLoaded = _a[0], setHasLoaded = _a[1];
    // Defaults
    var spinnerOptions = __assign({ size: 32, lines: 12, color: '#000', fadeIn: true, className: '' }, props);
    (0, hooks_1.useEffect)(function () {
        setHasLoaded(true);
        return function () {
            setHasLoaded(false);
        };
    }, []);
    var getFadeInOptions = function () {
        if (!spinnerOptions.fadeIn)
            return {};
        return {
            opacity: hasLoaded ? 1 : 0,
            transition: 'opacity .2s ease-in-out'
        };
    };
    return ((0, preact_1.h)("div", { className: spinnerOptions.className, style: __assign({ height: spinnerOptions.size, width: spinnerOptions.size }, getFadeInOptions()) }, Array.from(Array(spinnerOptions.lines).keys()).map(function (_, i) {
        var degrees = Math.round((360 / spinnerOptions.lines) * (i));
        var radius = spinnerOptions.size * 0.35;
        var animationDelay = (i / spinnerOptions.lines) - 1;
        return ((0, preact_1.h)("div", { key: i, style: {
                position: 'absolute',
                top: '45%',
                left: '40%',
                transform: "rotate(".concat(degrees, "deg) translateX(-").concat(radius, "px)"),
                transformOrigin: 'center',
                width: "".concat(spinnerOptions.size / 5, "px"),
                height: "".concat(spinnerOptions.size / 13, "px"),
                backgroundColor: spinnerOptions.color,
                borderRadius: "".concat(spinnerOptions.size / 6, "px"),
                animationDuration: '1s',
                animationDirection: 'linear',
                animationIterationCount: 'infinite',
                animationName: 'loading-spinner-line-fade',
                animationDelay: "".concat(animationDelay, "s")
            } }));
    })));
};
exports.default = LoadingSpinner;
